var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.70833 7.58333C3.30664 7.58333 3.79167 8.06836 3.79167 8.66667C3.79167 9.26498 3.30664 9.75 2.70833 9.75C2.11002 9.75 1.625 9.26498 1.625 8.66667C1.625 8.06836 2.11002 7.58333 2.70833 7.58333ZM2.70833 2.70833C3.30664 2.70833 3.79167 3.19336 3.79167 3.79167C3.79167 4.38998 3.30664 4.875 2.70833 4.875C2.11002 4.875 1.625 4.38998 1.625 3.79167C1.625 3.19336 2.11002 2.70833 2.70833 2.70833ZM7.58333 8.66667C7.58333 8.06836 7.09831 7.58333 6.5 7.58333C5.90169 7.58333 5.41667 8.06836 5.41667 8.66667C5.41667 9.26498 5.90169 9.75 6.5 9.75C7.09831 9.75 7.58333 9.26498 7.58333 8.66667ZM6.5 2.70833C7.09831 2.70833 7.58333 3.19336 7.58333 3.79167C7.58333 4.38998 7.09831 4.875 6.5 4.875C5.90169 4.875 5.41667 4.38998 5.41667 3.79167C5.41667 3.19336 5.90169 2.70833 6.5 2.70833ZM11.375 8.66667C11.375 8.06836 10.89 7.58333 10.2917 7.58333C9.69336 7.58333 9.20833 8.06836 9.20833 8.66667C9.20833 9.26498 9.69336 9.75 10.2917 9.75C10.89 9.75 11.375 9.26498 11.375 8.66667ZM10.2917 2.70833C10.89 2.70833 11.375 3.19336 11.375 3.79167C11.375 4.38998 10.89 4.875 10.2917 4.875C9.69336 4.875 9.20833 4.38998 9.20833 3.79167C9.20833 3.19336 9.69336 2.70833 10.2917 2.70833Z",
    fill: "#605F5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrag);
export default __webpack_public_path__ + "static/media/drag.e283febefefbb2aceb0fa326e93e4e86.svg";
export { ForwardRef as ReactComponent };